/**
 * Checks if a string can be parsed into a JS date object
 *
 * @param date The string to be checked
 */
export const isValidDateString = (date: string) => !isNaN(Date.parse(date));
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";